export default __webpack_public_path__ + "static/media/20.3e941ed9.png";